// Scope Templates for Estimating System
export const SCOPE_TEMPLATES = {
  // ═══════════════════════════════════════════════════════════════════════════
  // BATHROOM REMODEL
  // ═══════════════════════════════════════════════════════════════════════════
  BATHROOM: {
    name: 'Full Bathroom Remodel',
    triggers: ['bathroom', 'bath', 'restroom', 'powder room', 'powder', 'ensuite', 'en-suite', 'master bath', 'half bath', 'full bath', 'guest bath', 'lavatory', 'washroom', 'wc'],
    builderCost: 11150,
    items: [
      // DEMO & PROTECTION
      { group: 'Demo & Protection', name: 'Site Protection (Ram Board, ZipWall, 6-mil Poly)', cost: 250, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Demo & Protection', name: 'Bathroom Demo Labor (fixtures, flooring, drywall to studs)', cost: 800, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Demo & Protection', name: 'Debris Haul-Off (1/4 dumpster load)', cost: 200, qty: 1, unit: 'LS', type: 'Labor' },
      // ROUGH PLUMBING
      { group: 'Rough Plumbing', name: 'Plumbing Rough-In Labor', cost: 1200, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Rough Plumbing', name: 'PEX Supply Lines & Fittings', cost: 150, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Rough Plumbing', name: 'Drain/Vent Modifications', cost: 400, qty: 1, unit: 'LS', type: 'Labor' },
      // ROUGH ELECTRICAL
      { group: 'Rough Electrical', name: 'Electrical Rough-In Labor (circuits, boxes)', cost: 600, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Rough Electrical', name: 'GFCI Outlets', cost: 40, qty: 2, unit: 'EA', type: 'Material' },
      { group: 'Rough Electrical', name: 'Exhaust Fan (80 CFM)', cost: 120, qty: 1, unit: 'EA', type: 'Material' },
      { group: 'Rough Electrical', name: 'Exhaust Fan Duct & Vent Cap', cost: 80, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Rough Electrical', name: 'Vanity Light Circuit', cost: 150, qty: 1, unit: 'LS', type: 'Labor' },
      // INSULATION & DRYWALL
      { group: 'Insulation & Drywall', name: 'Batt Insulation (exterior walls, R-13)', cost: 200, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Insulation & Drywall', name: 'Moisture-Resistant Drywall (greenboard)', cost: 400, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Insulation & Drywall', name: 'Drywall Hang Labor', cost: 300, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Insulation & Drywall', name: 'Drywall Finish (tape, mud, sand)', cost: 400, qty: 1, unit: 'LS', type: 'Labor' },
      // TILE & FLOORING
      { group: 'Tile & Flooring', name: 'Cement Backer Board (Durock)', cost: 200, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Tile & Flooring', name: 'Floor Tile (12x24 porcelain)', cost: 8, qty: 50, unit: 'SF', type: 'Material' },
      { group: 'Tile & Flooring', name: 'Floor Tile Installation Labor', cost: 7, qty: 50, unit: 'SF', type: 'Labor' },
      { group: 'Tile & Flooring', name: 'Shower Wall Tile (subway)', cost: 10, qty: 60, unit: 'SF', type: 'Material' },
      { group: 'Tile & Flooring', name: 'Shower Tile Installation Labor', cost: 10, qty: 60, unit: 'SF', type: 'Labor' },
      { group: 'Tile & Flooring', name: 'Thinset, Grout & Sealer', cost: 150, qty: 1, unit: 'LS', type: 'Material' },
      // PAINT & TRIM
      { group: 'Paint & Trim', name: 'Primer + 2 Coats Paint (walls & ceiling)', cost: 400, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Paint & Trim', name: 'Paint Material (semi-gloss)', cost: 80, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Paint & Trim', name: 'Baseboard (primed MDF, 3-1/4")', cost: 100, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Paint & Trim', name: 'Baseboard Installation Labor', cost: 100, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Paint & Trim', name: 'Door/Window Casing', cost: 80, qty: 1, unit: 'LS', type: 'Material' },
      // FIXTURES & FINISH
      { group: 'Fixtures & Finish', name: 'Toilet (Kohler Highline)', cost: 280, qty: 1, unit: 'EA', type: 'Material' },
      { group: 'Fixtures & Finish', name: 'Toilet Installation Labor', cost: 120, qty: 1, unit: 'EA', type: 'Labor' },
      { group: 'Fixtures & Finish', name: 'Vanity w/ Top (36" single sink)', cost: 500, qty: 1, unit: 'EA', type: 'Material' },
      { group: 'Fixtures & Finish', name: 'Vanity Installation Labor', cost: 150, qty: 1, unit: 'EA', type: 'Labor' },
      { group: 'Fixtures & Finish', name: 'Vanity Faucet (single handle)', cost: 150, qty: 1, unit: 'EA', type: 'Material' },
      { group: 'Fixtures & Finish', name: 'Faucet Installation Labor', cost: 80, qty: 1, unit: 'EA', type: 'Labor' },
      { group: 'Fixtures & Finish', name: 'Mirror (frameless, 36x30)', cost: 120, qty: 1, unit: 'EA', type: 'Material' },
      { group: 'Fixtures & Finish', name: 'Towel Bars & Accessories', cost: 100, qty: 1, unit: 'LS', type: 'Material' },
      // SHOWER
      { group: 'Shower', name: 'Shower Valve (Delta Monitor)', cost: 180, qty: 1, unit: 'EA', type: 'Material' },
      { group: 'Shower', name: 'Shower Valve Installation Labor', cost: 200, qty: 1, unit: 'EA', type: 'Labor' },
      { group: 'Shower', name: 'Showerhead (handheld combo)', cost: 80, qty: 1, unit: 'EA', type: 'Material' },
      { group: 'Shower', name: 'Shower Door (frameless, 48")', cost: 600, qty: 1, unit: 'EA', type: 'Material' },
      { group: 'Shower', name: 'Shower Door Installation', cost: 200, qty: 1, unit: 'EA', type: 'Labor' },
    ],
  },

  // ═══════════════════════════════════════════════════════════════════════════
  // KITCHEN REMODEL
  // ═══════════════════════════════════════════════════════════════════════════
  KITCHEN: {
    name: 'Full Kitchen Remodel',
    triggers: ['kitchen', 'galley', 'kitchenette', 'cook', 'culinary'],
    builderCost: 28500,
    items: [
      // DEMO & PROTECTION
      { group: 'Demo & Protection', name: 'Site Protection (Ram Board, ZipWall, 6-mil Poly)', cost: 350, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Demo & Protection', name: 'Cabinet & Countertop Removal Labor', cost: 600, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Demo & Protection', name: 'Flooring Demo', cost: 2, qty: 200, unit: 'SF', type: 'Labor' },
      { group: 'Demo & Protection', name: 'Debris Haul-Off (1/2 dumpster)', cost: 350, qty: 1, unit: 'LS', type: 'Labor' },
      // ROUGH PLUMBING
      { group: 'Rough Plumbing', name: 'Plumbing Rough-In (Sink + Dishwasher)', cost: 800, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Rough Plumbing', name: 'Supply Lines & Shut-offs', cost: 150, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Rough Plumbing', name: 'Garbage Disposal Rough', cost: 150, qty: 1, unit: 'LS', type: 'Labor' },
      // ROUGH ELECTRICAL
      { group: 'Rough Electrical', name: 'Electrical Panel - 5 New Circuits', cost: 1200, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Rough Electrical', name: '20A Kitchen Circuits (GFCI protected)', cost: 100, qty: 5, unit: 'EA', type: 'Material' },
      { group: 'Rough Electrical', name: 'Island Pendant Wiring', cost: 300, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Rough Electrical', name: 'Under-Cabinet Lighting Wiring', cost: 400, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Rough Electrical', name: 'Dedicated Appliance Circuits (Range, Fridge, DW, Micro)', cost: 200, qty: 4, unit: 'EA', type: 'Labor' },
      // DRYWALL & PAINT
      { group: 'Drywall & Paint', name: 'Drywall Repair/Patching', cost: 400, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Drywall & Paint', name: 'Prime & Paint (walls & ceiling)', cost: 600, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Drywall & Paint', name: 'Paint Material', cost: 150, qty: 1, unit: 'LS', type: 'Material' },
      // CABINETS
      { group: 'Cabinets', name: 'Base Cabinets (soft-close)', cost: 250, qty: 15, unit: 'LF', type: 'Material' },
      { group: 'Cabinets', name: 'Wall Cabinets (42" height)', cost: 200, qty: 12, unit: 'LF', type: 'Material' },
      { group: 'Cabinets', name: 'Cabinet Installation Labor', cost: 80, qty: 15, unit: 'LF', type: 'Labor' },
      { group: 'Cabinets', name: 'Cabinet Hardware (pulls & knobs)', cost: 200, qty: 1, unit: 'LS', type: 'Material' },
      // COUNTERTOPS
      { group: 'Countertops', name: 'Quartz Countertops (Level 2)', cost: 75, qty: 45, unit: 'SF', type: 'Material' },
      { group: 'Countertops', name: 'Countertop Template & Install', cost: 25, qty: 45, unit: 'SF', type: 'Labor' },
      { group: 'Countertops', name: 'Undermount Sink Cutout', cost: 200, qty: 1, unit: 'EA', type: 'Labor' },
      // BACKSPLASH
      { group: 'Backsplash', name: 'Backsplash Tile (subway or mosaic)', cost: 15, qty: 30, unit: 'SF', type: 'Material' },
      { group: 'Backsplash', name: 'Backsplash Installation Labor', cost: 20, qty: 30, unit: 'SF', type: 'Labor' },
      { group: 'Backsplash', name: 'Thinset & Grout', cost: 100, qty: 1, unit: 'LS', type: 'Material' },
      // FLOORING
      { group: 'Flooring', name: 'LVP Flooring (waterproof)', cost: 5, qty: 200, unit: 'SF', type: 'Material' },
      { group: 'Flooring', name: 'LVP Installation Labor', cost: 3, qty: 200, unit: 'SF', type: 'Labor' },
      { group: 'Flooring', name: 'Underlayment', cost: 1, qty: 200, unit: 'SF', type: 'Material' },
      // FIXTURES
      { group: 'Fixtures', name: 'Kitchen Sink (undermount SS)', cost: 350, qty: 1, unit: 'EA', type: 'Material' },
      { group: 'Fixtures', name: 'Kitchen Faucet (pull-down)', cost: 250, qty: 1, unit: 'EA', type: 'Material' },
      { group: 'Fixtures', name: 'Sink & Faucet Installation', cost: 200, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Fixtures', name: 'Garbage Disposal (1/2 HP)', cost: 150, qty: 1, unit: 'EA', type: 'Material' },
      // APPLIANCES (Install Only)
      { group: 'Appliance Install', name: 'Range/Oven Hookup', cost: 150, qty: 1, unit: 'EA', type: 'Labor' },
      { group: 'Appliance Install', name: 'Dishwasher Install', cost: 150, qty: 1, unit: 'EA', type: 'Labor' },
      { group: 'Appliance Install', name: 'Microwave/Hood Install', cost: 200, qty: 1, unit: 'EA', type: 'Labor' },
      { group: 'Appliance Install', name: 'Refrigerator Water Line', cost: 150, qty: 1, unit: 'LS', type: 'Labor' },
      // TRIM
      { group: 'Trim & Finish', name: 'Baseboard & Shoe Molding', cost: 200, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Trim & Finish', name: 'Trim Installation Labor', cost: 200, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Trim & Finish', name: 'Final Clean & Touch-up', cost: 150, qty: 1, unit: 'LS', type: 'Labor' },
    ],
  },

  // ═══════════════════════════════════════════════════════════════════════════
  // DECK BUILD
  // ═══════════════════════════════════════════════════════════════════════════
  DECK: {
    name: 'Deck Build (300 SF)',
    triggers: ['deck', 'porch', 'veranda', 'patio deck', 'outdoor deck', 'back deck', 'front porch'],
    builderCost: 15200,
    items: [
      // PERMITS & PLANNING
      { group: 'Permits & Planning', name: 'Building Permit', cost: 400, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Permits & Planning', name: 'Engineering/Plans (if required)', cost: 500, qty: 1, unit: 'LS', type: 'Labor' },
      // FOUNDATION
      { group: 'Foundation', name: 'Post Footings (Sonotube 12")', cost: 75, qty: 4, unit: 'EA', type: 'Material' },
      { group: 'Foundation', name: 'Concrete (for footings)', cost: 50, qty: 4, unit: 'EA', type: 'Material' },
      { group: 'Foundation', name: 'Post Anchors (Simpson)', cost: 25, qty: 4, unit: 'EA', type: 'Material' },
      { group: 'Foundation', name: 'Footing Excavation & Pour Labor', cost: 100, qty: 4, unit: 'EA', type: 'Labor' },
      // STRUCTURE
      { group: 'Structure', name: 'Ledger Board (2x10 PT)', cost: 150, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Structure', name: 'Ledger Flashing & Sealant', cost: 80, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Structure', name: '6x6 PT Posts', cost: 50, qty: 4, unit: 'EA', type: 'Material' },
      { group: 'Structure', name: 'Beam (2x10 PT doubled)', cost: 200, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Structure', name: 'Joists (2x10 PT @ 16" OC)', cost: 15, qty: 25, unit: 'EA', type: 'Material' },
      { group: 'Structure', name: 'Joist Hangers & Hardware', cost: 150, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Structure', name: 'Framing Labor', cost: 1500, qty: 1, unit: 'LS', type: 'Labor' },
      // DECKING
      { group: 'Decking', name: 'Composite Decking (Trex Select)', cost: 8, qty: 300, unit: 'SF', type: 'Material' },
      { group: 'Decking', name: 'Hidden Fasteners', cost: 300, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Decking', name: 'Decking Installation Labor', cost: 8, qty: 300, unit: 'SF', type: 'Labor' },
      { group: 'Decking', name: 'Fascia Board', cost: 200, qty: 1, unit: 'LS', type: 'Material' },
      // RAILING
      { group: 'Railing', name: 'Composite Railing System', cost: 50, qty: 40, unit: 'LF', type: 'Material' },
      { group: 'Railing', name: 'Railing Installation Labor', cost: 25, qty: 40, unit: 'LF', type: 'Labor' },
      { group: 'Railing', name: 'Post Caps & Accessories', cost: 150, qty: 1, unit: 'LS', type: 'Material' },
      // STAIRS
      { group: 'Stairs', name: 'Stair Stringers (PT, set of 3)', cost: 200, qty: 1, unit: 'SET', type: 'Material' },
      { group: 'Stairs', name: 'Stair Treads (composite)', cost: 50, qty: 4, unit: 'EA', type: 'Material' },
      { group: 'Stairs', name: 'Stair Railing', cost: 300, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Stairs', name: 'Stair Build Labor', cost: 400, qty: 1, unit: 'LS', type: 'Labor' },
      // FINAL
      { group: 'Final', name: 'Final Inspection', cost: 100, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Final', name: 'Cleanup & Debris Removal', cost: 200, qty: 1, unit: 'LS', type: 'Labor' },
    ],
  },

  // ═══════════════════════════════════════════════════════════════════════════
  // BASEMENT FINISH
  // ═══════════════════════════════════════════════════════════════════════════
  BASEMENT: {
    name: 'Basement Finish (600 SF)',
    triggers: ['basement', 'lower level', 'downstairs', 'cellar', 'below grade', 'finished basement'],
    builderCost: 32000,
    items: [
      // PERMITS & PLANNING
      { group: 'Permits & Planning', name: 'Building Permit', cost: 500, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Permits & Planning', name: 'Egress Window Permit (if adding bedroom)', cost: 200, qty: 1, unit: 'LS', type: 'Labor' },
      // PREP & WATERPROOFING
      { group: 'Prep & Waterproofing', name: 'Moisture Testing', cost: 150, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Prep & Waterproofing', name: 'Waterproof Paint (DryLok)', cost: 200, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Prep & Waterproofing', name: 'Waterproofing Labor', cost: 300, qty: 1, unit: 'LS', type: 'Labor' },
      // FRAMING
      { group: 'Framing', name: 'Furring Strips / Wall Framing (PT bottom plate)', cost: 4, qty: 120, unit: 'LF', type: 'Material' },
      { group: 'Framing', name: 'Framing Labor', cost: 8, qty: 120, unit: 'LF', type: 'Labor' },
      { group: 'Framing', name: 'Ceiling Furring/Framing', cost: 600, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Framing', name: 'Interior Wall Framing (bedroom partition)', cost: 800, qty: 1, unit: 'LS', type: 'Labor' },
      // INSULATION
      { group: 'Insulation', name: 'Rigid Foam Insulation (walls, R-10)', cost: 2, qty: 600, unit: 'SF', type: 'Material' },
      { group: 'Insulation', name: 'Batt Insulation (ceiling, if needed)', cost: 400, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Insulation', name: 'Insulation Installation Labor', cost: 800, qty: 1, unit: 'LS', type: 'Labor' },
      // ELECTRICAL
      { group: 'Electrical', name: 'Electrical Rough-In (circuits, boxes)', cost: 1500, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Electrical', name: 'Recessed Lights (6" LED)', cost: 50, qty: 12, unit: 'EA', type: 'Material' },
      { group: 'Electrical', name: 'Recessed Light Installation', cost: 75, qty: 12, unit: 'EA', type: 'Labor' },
      { group: 'Electrical', name: 'Outlets & Switches', cost: 15, qty: 12, unit: 'EA', type: 'Material' },
      { group: 'Electrical', name: 'Smoke/CO Detectors (code required)', cost: 50, qty: 2, unit: 'EA', type: 'Material' },
      // DRYWALL
      { group: 'Drywall', name: 'Drywall (1/2" walls & ceiling)', cost: 1, qty: 1200, unit: 'SF', type: 'Material' },
      { group: 'Drywall', name: 'Drywall Hang Labor', cost: 1.50, qty: 1200, unit: 'SF', type: 'Labor' },
      { group: 'Drywall', name: 'Drywall Finish (tape, mud, sand)', cost: 1.50, qty: 1200, unit: 'SF', type: 'Labor' },
      // PAINT
      { group: 'Paint', name: 'Prime & Paint (walls & ceiling)', cost: 1, qty: 1200, unit: 'SF', type: 'Labor' },
      { group: 'Paint', name: 'Paint Material', cost: 300, qty: 1, unit: 'LS', type: 'Material' },
      // FLOORING
      { group: 'Flooring', name: 'LVP Flooring (waterproof)', cost: 5, qty: 600, unit: 'SF', type: 'Material' },
      { group: 'Flooring', name: 'LVP Installation Labor', cost: 3, qty: 600, unit: 'SF', type: 'Labor' },
      { group: 'Flooring', name: 'Underlayment (moisture barrier)', cost: 1, qty: 600, unit: 'SF', type: 'Material' },
      // TRIM
      { group: 'Trim & Doors', name: 'Baseboard (primed MDF)', cost: 2, qty: 120, unit: 'LF', type: 'Material' },
      { group: 'Trim & Doors', name: 'Baseboard Installation Labor', cost: 2, qty: 120, unit: 'LF', type: 'Labor' },
      { group: 'Trim & Doors', name: 'Interior Door (prehung)', cost: 250, qty: 2, unit: 'EA', type: 'Material' },
      { group: 'Trim & Doors', name: 'Door Installation Labor', cost: 150, qty: 2, unit: 'EA', type: 'Labor' },
      // EGRESS (if bedroom)
      { group: 'Egress Window', name: 'Egress Window Well & Window', cost: 2500, qty: 1, unit: 'EA', type: 'Material' },
      { group: 'Egress Window', name: 'Egress Installation (cut, install, waterproof)', cost: 1500, qty: 1, unit: 'EA', type: 'Labor' },
      // FINAL
      { group: 'Final', name: 'Final Inspection', cost: 100, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Final', name: 'Cleanup', cost: 200, qty: 1, unit: 'LS', type: 'Labor' },
    ],
  },

  // ═══════════════════════════════════════════════════════════════════════════
  // BEDROOM (For New Build chaining)
  // ═══════════════════════════════════════════════════════════════════════════
  BEDROOM: {
    name: 'Bedroom Finish (12x14)',
    triggers: ['bedroom', 'master bedroom', 'guest room', 'spare room'],
    builderCost: 8500,
    items: [
      { group: 'Framing', name: 'Wall Framing (if new)', cost: 800, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Electrical', name: 'Electrical Rough-In (AFCI required)', cost: 600, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Electrical', name: 'Outlets & Switches', cost: 15, qty: 6, unit: 'EA', type: 'Material' },
      { group: 'Electrical', name: 'Ceiling Light/Fan Box', cost: 150, qty: 1, unit: 'EA', type: 'Labor' },
      { group: 'Insulation', name: 'Batt Insulation (R-13)', cost: 400, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Drywall', name: 'Drywall (walls & ceiling)', cost: 1200, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Drywall', name: 'Drywall Labor (hang, tape, finish)', cost: 1500, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Paint', name: 'Prime & Paint', cost: 600, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Flooring', name: 'Carpet or LVP', cost: 1000, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Flooring', name: 'Flooring Installation', cost: 500, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Trim', name: 'Baseboard & Door Casing', cost: 300, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Trim', name: 'Trim Installation Labor', cost: 200, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Closet', name: 'Closet Shelving System', cost: 250, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Door', name: 'Interior Door (prehung)', cost: 250, qty: 1, unit: 'EA', type: 'Material' },
      { group: 'Door', name: 'Door Installation', cost: 150, qty: 1, unit: 'EA', type: 'Labor' },
    ],
  },

  // ═══════════════════════════════════════════════════════════════════════════
  // FOUNDATION (For New Build chaining)
  // ═══════════════════════════════════════════════════════════════════════════
  FOUNDATION: {
    name: 'Foundation (1500 SF Slab)',
    triggers: ['foundation', 'slab', 'concrete foundation', 'footings'],
    builderCost: 18500,
    items: [
      // SITE PREP
      { group: 'Site Prep', name: 'Site Survey & Layout', cost: 800, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Site Prep', name: 'Excavation & Grading', cost: 3500, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Site Prep', name: 'Soil Compaction', cost: 1200, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Site Prep', name: 'Gravel Base (4")', cost: 2, qty: 1500, unit: 'SF', type: 'Material' },
      // FOOTINGS
      { group: 'Footings', name: 'Footing Forms', cost: 800, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Footings', name: 'Footing Rebar (#4 @ 12" OC)', cost: 1200, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Footings', name: 'Footing Concrete (3000 PSI)', cost: 150, qty: 12, unit: 'CY', type: 'Material' },
      { group: 'Footings', name: 'Footing Pour Labor', cost: 1500, qty: 1, unit: 'LS', type: 'Labor' },
      // SLAB
      { group: 'Slab', name: 'Vapor Barrier (10-mil)', cost: 0.15, qty: 1500, unit: 'SF', type: 'Material' },
      { group: 'Slab', name: 'Wire Mesh (6x6 W1.4)', cost: 0.50, qty: 1500, unit: 'SF', type: 'Material' },
      { group: 'Slab', name: 'Slab Concrete (3500 PSI, 4")', cost: 6, qty: 1500, unit: 'SF', type: 'Material' },
      { group: 'Slab', name: 'Concrete Finishing Labor', cost: 2500, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Slab', name: 'Concrete Pump (if needed)', cost: 800, qty: 1, unit: 'LS', type: 'Labor' },
      // ANCHOR BOLTS & STRAPS
      { group: 'Anchors', name: 'Anchor Bolts (J-Bolts)', cost: 5, qty: 50, unit: 'EA', type: 'Material' },
      { group: 'Anchors', name: 'Hold-Down Straps (Simpson)', cost: 25, qty: 12, unit: 'EA', type: 'Material' },
    ],
  },

  // ═══════════════════════════════════════════════════════════════════════════
  // FRAMING (For New Build chaining)
  // ═══════════════════════════════════════════════════════════════════════════
  FRAMING: {
    name: 'House Framing (1500 SF)',
    triggers: ['framing', 'frame', 'structure', 'walls', 'roof framing'],
    builderCost: 35000,
    items: [
      // WALL FRAMING
      { group: 'Wall Framing', name: 'Bottom Plate (PT 2x4)', cost: 3, qty: 200, unit: 'LF', type: 'Material' },
      { group: 'Wall Framing', name: 'Studs (2x4 @ 16" OC)', cost: 5, qty: 400, unit: 'EA', type: 'Material' },
      { group: 'Wall Framing', name: 'Top Plates (Double 2x4)', cost: 3, qty: 400, unit: 'LF', type: 'Material' },
      { group: 'Wall Framing', name: 'Headers (2x10)', cost: 200, qty: 8, unit: 'EA', type: 'Material' },
      { group: 'Wall Framing', name: 'Wall Framing Labor', cost: 8000, qty: 1, unit: 'LS', type: 'Labor' },
      // ROOF FRAMING
      { group: 'Roof Framing', name: 'Roof Trusses (24" OC)', cost: 150, qty: 30, unit: 'EA', type: 'Material' },
      { group: 'Roof Framing', name: 'Truss Delivery & Crane', cost: 1200, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Roof Framing', name: 'Roof Sheathing (7/16" OSB)', cost: 35, qty: 50, unit: 'SHT', type: 'Material' },
      { group: 'Roof Framing', name: 'Fascia Board (1x8)', cost: 2, qty: 150, unit: 'LF', type: 'Material' },
      { group: 'Roof Framing', name: 'Roof Framing Labor', cost: 4500, qty: 1, unit: 'LS', type: 'Labor' },
      // FLOOR FRAMING (if raised)
      { group: 'Floor Framing', name: 'Floor Joists (2x10 @ 16" OC)', cost: 12, qty: 100, unit: 'EA', type: 'Material' },
      { group: 'Floor Framing', name: 'Rim Board (2x10)', cost: 8, qty: 150, unit: 'LF', type: 'Material' },
      { group: 'Floor Framing', name: 'Subfloor (3/4" T&G OSB)', cost: 40, qty: 50, unit: 'SHT', type: 'Material' },
      { group: 'Floor Framing', name: 'Floor Framing Labor', cost: 3500, qty: 1, unit: 'LS', type: 'Labor' },
      // HARDWARE
      { group: 'Framing Hardware', name: 'Joist Hangers', cost: 3, qty: 100, unit: 'EA', type: 'Material' },
      { group: 'Framing Hardware', name: 'Hurricane Ties', cost: 2, qty: 60, unit: 'EA', type: 'Material' },
      { group: 'Framing Hardware', name: 'Nails & Fasteners', cost: 500, qty: 1, unit: 'LS', type: 'Material' },
    ],
  },

  // ═══════════════════════════════════════════════════════════════════════════
  // WHOLE HOUSE PLUMBING ROUGH (For New Build chaining)
  // ═══════════════════════════════════════════════════════════════════════════
  PLUMBING_ROUGH: {
    name: 'Whole House Plumbing Rough-In',
    triggers: ['plumbing rough', 'rough plumbing', 'plumbing rough-in', 'house plumbing'],
    builderCost: 12000,
    items: [
      // SUPPLY LINES
      { group: 'Supply Lines', name: 'Main Water Line (1" PEX)', cost: 3, qty: 100, unit: 'LF', type: 'Material' },
      { group: 'Supply Lines', name: 'Hot/Cold Distribution (3/4" PEX)', cost: 2, qty: 300, unit: 'LF', type: 'Material' },
      { group: 'Supply Lines', name: 'PEX Fittings & Manifold', cost: 400, qty: 1, unit: 'LS', type: 'Material' },
      { group: 'Supply Lines', name: 'Shut-Off Valves', cost: 15, qty: 20, unit: 'EA', type: 'Material' },
      // DRAIN/VENT
      { group: 'DWV System', name: 'Main Drain Line (4" PVC)', cost: 8, qty: 50, unit: 'LF', type: 'Material' },
      { group: 'DWV System', name: 'Branch Drains (2" PVC)', cost: 4, qty: 150, unit: 'LF', type: 'Material' },
      { group: 'DWV System', name: 'Vent Stack (3" PVC)', cost: 6, qty: 40, unit: 'LF', type: 'Material' },
      { group: 'DWV System', name: 'Cleanouts', cost: 25, qty: 4, unit: 'EA', type: 'Material' },
      { group: 'DWV System', name: 'PVC Fittings & Cement', cost: 300, qty: 1, unit: 'LS', type: 'Material' },
      // WATER HEATER
      { group: 'Water Heater', name: 'Water Heater (50 Gal Gas)', cost: 800, qty: 1, unit: 'EA', type: 'Material' },
      { group: 'Water Heater', name: 'Water Heater Installation', cost: 400, qty: 1, unit: 'EA', type: 'Labor' },
      { group: 'Water Heater', name: 'Expansion Tank', cost: 80, qty: 1, unit: 'EA', type: 'Material' },
      // LABOR
      { group: 'Plumbing Labor', name: 'Plumbing Rough-In Labor', cost: 6000, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Plumbing Labor', name: 'Permit & Inspection', cost: 400, qty: 1, unit: 'LS', type: 'Labor' },
    ],
  },

  // ═══════════════════════════════════════════════════════════════════════════
  // WHOLE HOUSE ELECTRICAL ROUGH (For New Build chaining)
  // ═══════════════════════════════════════════════════════════════════════════
  ELECTRICAL_ROUGH: {
    name: 'Whole House Electrical Rough-In',
    triggers: ['electrical rough', 'rough electrical', 'electrical rough-in', 'house electrical', 'wiring'],
    builderCost: 15000,
    items: [
      // PANEL
      { group: 'Electrical Panel', name: 'Main Panel (200A)', cost: 400, qty: 1, unit: 'EA', type: 'Material' },
      { group: 'Electrical Panel', name: 'Panel Installation', cost: 800, qty: 1, unit: 'EA', type: 'Labor' },
      { group: 'Electrical Panel', name: 'Meter Base', cost: 150, qty: 1, unit: 'EA', type: 'Material' },
      { group: 'Electrical Panel', name: 'Grounding System', cost: 300, qty: 1, unit: 'LS', type: 'Material' },
      // CIRCUITS
      { group: 'Circuits', name: '14/2 Romex (Lighting)', cost: 0.50, qty: 500, unit: 'LF', type: 'Material' },
      { group: 'Circuits', name: '12/2 Romex (Outlets)', cost: 0.70, qty: 800, unit: 'LF', type: 'Material' },
      { group: 'Circuits', name: '10/2 Romex (Appliances)', cost: 1.20, qty: 100, unit: 'LF', type: 'Material' },
      { group: 'Circuits', name: 'Circuit Breakers (15-50A)', cost: 10, qty: 30, unit: 'EA', type: 'Material' },
      // BOXES & DEVICES
      { group: 'Boxes & Devices', name: 'Outlet Boxes', cost: 2, qty: 60, unit: 'EA', type: 'Material' },
      { group: 'Boxes & Devices', name: 'Switch Boxes', cost: 2, qty: 30, unit: 'EA', type: 'Material' },
      { group: 'Boxes & Devices', name: 'Light Fixture Boxes', cost: 3, qty: 25, unit: 'EA', type: 'Material' },
      { group: 'Boxes & Devices', name: 'AFCI Breakers (Bedrooms)', cost: 40, qty: 4, unit: 'EA', type: 'Material' },
      { group: 'Boxes & Devices', name: 'GFCI Outlets (Kitchen/Bath)', cost: 25, qty: 10, unit: 'EA', type: 'Material' },
      // LABOR
      { group: 'Electrical Labor', name: 'Electrical Rough-In Labor', cost: 8000, qty: 1, unit: 'LS', type: 'Labor' },
      { group: 'Electrical Labor', name: 'Permit & Inspection', cost: 500, qty: 1, unit: 'LS', type: 'Labor' },
    ],
  },
};
